import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FormGroup, FormBuilder, Validators} from "@angular/forms";

@Component({
  selector: "app-conserve-ecology",
  templateUrl: "./conserve-ecology.component.html",
  styleUrls: ["./conserve-ecology.component.scss"],
})
export class ConserveEcologyComponent implements OnInit, OnChanges {
  @Input() formTabData: any; // Input property to receive formData from the parent component
  dateFormat = "dd/MM/yyyy";

  currentDate: Date;
  ecologyFormGroup: FormGroup;
  biodiverseFormGroup: FormGroup;
  khuVucRungOptions: string[] = [
    "Không",
    "Rừng nguyên sinh",
    "Rừng phòng hộ",
    "Rừng sản xuất",
  ];
  mohinhCanhTacOptions: string[] = [
    "Đơn canh",
    "Đa canh: Ca cao - Dừa",
    "Đa canh: Ca cao - Điều",
    "Đa canh: Ca cao - Cà phê",
    "Đa canh: Mô hình khác",
    "Nông lâm kết hợp",
    "Khác",
  ];
  soThangDuNuocTroiOptions: string[] = [
    "12",
    "Trên 10 tháng",
    "Trên 8 tháng",
    "Trên 6 tháng",
    "Dưới 6 tháng",
  ];
  heThongTuoiOptions: string[] = [
    "Tưới tràn",
    "Tưới dí",
    "Tưới tay",
    "Ống tưới",
    "Béc phun",
    "Nhỏ giọt",
    "Không",
    "Khác",
  ];
  nguonNuocOptions: string[] = [
    "Sông",
    "Suối",
    "Ao",
    "Hồ",
    "Giếng",
    "Kênh",
    "Khác",
  ];
  dotLuaOption: string[] = ["Trong vườn", "Ngoài vườn", "Không"];
  mucDichDotLuaOptions: string[] = [
    "Dọn sạch vườn",
    "Phòng trừ dịch hại",
    "Khác",
  ];
  nguonNangLuongOptions: string[] = [
    "Điện",
    "Xăng dầu",
    "Năng lượng mặt trời",
    "Thế năng",
    "Khác",
    "Không",
  ];
  suHienDienCuaChimOptions: string[] = [
    "Đại bàng",
    "Diều hâu",
    "Cắt",
    "Bìm Bịp",
    "Cú mèo",
    "Khác",
    "Không",
  ];
  yesNoOptions: string[] = ["Có", "Không"];
  suHienDienCuaDongVatGamNhamOptions: string[] = [
    "Sóc",
    "Chuột",
    "Khác",
    "Không",
  ];
  mucDichSanBatDongVatGamNhamOptions: string[] = [
    "Bảo vệ cây trồng",
    "Thịt",
    "Nuôi nhốt",
    "Buôn bán",
    "Khác",
    "Không",
  ];
  suHienDienCuaDongVatNguyCapOptions: string[] = ["Động vật nguy cấp", "Không"];
  suDungThienDichOptions: string[] = [
    "Có hiện diện",
    "Bảo tồn",
    "Diệt trừ bị động",
    "Diệt trừ chủ động",
    "Không",
  ];
  tenCuaThienDichOptions: string[] = [
    "Kiến đen",
    "Kiến vàng",
    "Nhện",
    "Bọ ngựa",
    "Bọ rùa",
    "Khác",
  ];
  constructor(private fb: FormBuilder) {}

  private serializeFormGroup(formGroup: FormGroup): any {
    const serialized = {};
    for (const controlName in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(controlName)) {
        serialized[controlName] = formGroup.get(controlName).value;
      }
    }
    return serialized;
  }

  submitForm() {
    if (!this.ecologyFormGroup.value.khuVucRung || this.ecologyFormGroup.value.khuVucRung === '') {
      this.ecologyFormGroup.get('ngayGhiNhan').setValue(null);
    }
    if (!this.biodiverseFormGroup.value.suHienDienCuaChim || this.biodiverseFormGroup.value.suHienDienCuaChim === '') {
      this.biodiverseFormGroup.get('ngayGhiNhan').setValue(null);
    }
    const formData = {
      ecologyFormGroup: this.serializeFormGroup(this.ecologyFormGroup),
      biodiverseFormGroup: this.serializeFormGroup(this.biodiverseFormGroup),
    };

    return formData;
  }

  private initializeEcologyFormGroup() {
    this.ecologyFormGroup = this.fb.group({
      ngayGhiNhan: [this.currentDate],
      khuVucRung: [null, Validators.required],
      khoangCach: [null],
      mohinhCanhTac: [null, Validators.required],
      customMoHinhCanhTac: [null],
      tenCayCheBongTamThoi: [null],
      soLuongCayCheBong12m: [null],
      tenCayCheBong12m: [null],
      soLuongCayCheBong5_12m: [null],
      tenCayCheBong5_12m: [null],
      soLuongCayThanGoXen5m: [null],
      tenCayThanGoXen5m: [null],
      soThangDuNuocTroi: [null, Validators.required],
      heThongTuoi: [null, Validators.required],
      customHeThongTuoi: [null],
      nguonNuoc: [null, Validators.required],
      customNguonNuoc: [null],
      dotLua: [null, Validators.required],
      mucDichDotLua: [null],
      customMucDichDotLua: [null],
      nguonNangLuong: [null],
      customNguonNangLuong: [null],
      tenNguonO_NhiemTiemTang: [null],
      dienGiaiNguonO_Nhiem: [null],
    });
  }

  private initializeBiodeverseFormGroup() {
    this.biodiverseFormGroup = this.fb.group({
      ngayGhiNhan: [this.currentDate, Validators.required],
      suHienDienCuaChim: [null, Validators.required],
      customSuHienDienCuaChim: [null],
      sanBatChim: [null, Validators.required],
      suHienDienCuaDongVatGamNham: [null, Validators.required],
      customSuHienDienCuaDongVatGamNham: [null],
      mucDichSanBatDongVatGamNham: [null],
      customMucDichSanBatDongVatGamNham: [null],
      suHienDienCuaDongVatNguyCap: [null, Validators.required],
      tenDongVatNguyCap: [null],
      tenDongVatHoangDaKhac: [null],
      suDungSucLaoDongTuDongVat: [null, Validators.required],
      tenDongVatMucDichSuDung: [null],
      suDungThienDich: [null, Validators.required],
      tenCuaThienDich: [null, Validators.required],
      customTenCuaThienDich: [null],
    });
  }

  ngOnInit(): void {
    this.currentDate = new Date();
    this.initializeBiodeverseFormGroup();
    this.initializeEcologyFormGroup();

    this.ecologyFormGroup
      .get("mohinhCanhTac")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.ecologyFormGroup.get("customMoHinhCanhTac").setValue(null);
        }
      });

    this.ecologyFormGroup
      .get("nguonNuoc")
      .valueChanges.subscribe((selectedOptions) => {
        const isKhacSelected = selectedOptions.includes("Khác");
        if (!isKhacSelected) {
          // Reset the custom input value when 'Khác' is not selected
          this.ecologyFormGroup.get("customNguonNuoc").setValue(null);
        }
      });

    this.ecologyFormGroup
      .get("heThongTuoi")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.ecologyFormGroup.get("customHeThongTuoi").setValue(null);
        }
      });

    this.ecologyFormGroup
      .get("mucDichDotLua")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.ecologyFormGroup.get("customMucDichDotLua").setValue(null);
        }
      });

    this.ecologyFormGroup
      .get("nguonNangLuong")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.ecologyFormGroup.get("customNguonNangLuong").setValue(null);
        }
      });

    this.biodiverseFormGroup
      .get("suHienDienCuaChim")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.biodiverseFormGroup
            .get("customSuHienDienCuaChim")
            .setValue(null);
        }
      });

    this.biodiverseFormGroup
      .get("suHienDienCuaDongVatGamNham")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.biodiverseFormGroup
            .get("customSuHienDienCuaDongVatGamNham")
            .setValue(null);
        }
      });

    this.biodiverseFormGroup
      .get("mucDichSanBatDongVatGamNham")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.biodiverseFormGroup
            .get("customMucDichSanBatDongVatGamNham")
            .setValue(null);
        }
      });

    this.biodiverseFormGroup
      .get("tenCuaThienDich")
      .valueChanges.subscribe((selectedOption) => {
        if (selectedOption !== "Khác") {
          // Reset the custom input value when 'Khác' is not selected
          this.biodiverseFormGroup.get("customTenCuaThienDich").setValue(null);
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.formTabData) {
      return; // Exit early if formTabData is not defined
    }

    if (this.formTabData) {
      // Reset the form controls when userId in formTabData changes
      this.initializeBiodeverseFormGroup();
      this.initializeEcologyFormGroup();
    }

    try {
      if (this.formTabData.baoTonHeSinhThai) {
        const trimmedJsonString = this.formTabData.baoTonHeSinhThai.trim();

        const conserveEcologyData = JSON.parse(trimmedJsonString);

        if (conserveEcologyData) {
          // Check if conserveEcologyData is defined

          this.setFormValues(
            this.ecologyFormGroup,
            conserveEcologyData.ecologyFormGroup
          );

          this.setFormValues(
            this.biodiverseFormGroup,
            conserveEcologyData.biodiverseFormGroup
          );
        }
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
      // Handle the error or provide appropriate fallback behavior
    }
    this.ecologyFormGroup
    .get("nguonNuoc")
    .valueChanges.subscribe((selectedOptions) => {
      const isKhacSelected = selectedOptions.includes("Khác");
      if (!isKhacSelected) {
        // Reset the custom input value when 'Khác' is not selected
        this.ecologyFormGroup.get("customNguonNuoc").setValue(null);
      }
    });
    this.ecologyFormGroup
    .get("heThongTuoi")
    .valueChanges.subscribe((selectedOption) => {
      if (selectedOption !== "Khác") {
        // Reset the custom input value when 'Khác' is not selected
        this.ecologyFormGroup.get("customHeThongTuoi").setValue(null);
      }
    });

  this.ecologyFormGroup
    .get("mucDichDotLua")
    .valueChanges.subscribe((selectedOption) => {
      if (selectedOption !== "Khác") {
        // Reset the custom input value when 'Khác' is not selected
        this.ecologyFormGroup.get("customMucDichDotLua").setValue(null);
      }
    });

  this.ecologyFormGroup
    .get("nguonNangLuong")
    .valueChanges.subscribe((selectedOption) => {
      if (selectedOption !== "Khác") {
        // Reset the custom input value when 'Khác' is not selected
        this.ecologyFormGroup.get("customNguonNangLuong").setValue(null);
      }
    });

  this.biodiverseFormGroup
    .get("suHienDienCuaChim")
    .valueChanges.subscribe((selectedOption) => {
      if (selectedOption !== "Khác") {
        // Reset the custom input value when 'Khác' is not selected
        this.biodiverseFormGroup
          .get("customSuHienDienCuaChim")
          .setValue(null);
      }
    });

  this.biodiverseFormGroup
    .get("suHienDienCuaDongVatGamNham")
    .valueChanges.subscribe((selectedOption) => {
      if (selectedOption !== "Khác") {
        // Reset the custom input value when 'Khác' is not selected
        this.biodiverseFormGroup
          .get("customSuHienDienCuaDongVatGamNham")
          .setValue(null);
      }
    });

  this.biodiverseFormGroup
    .get("mucDichSanBatDongVatGamNham")
    .valueChanges.subscribe((selectedOption) => {
      if (selectedOption !== "Khác") {
        // Reset the custom input value when 'Khác' is not selected
        this.biodiverseFormGroup
          .get("customMucDichSanBatDongVatGamNham")
          .setValue(null);
      }
    });

  this.biodiverseFormGroup
    .get("tenCuaThienDich")
    .valueChanges.subscribe((selectedOption) => {
      if (selectedOption !== "Khác") {
        // Reset the custom input value when 'Khác' is not selected
        this.biodiverseFormGroup.get("customTenCuaThienDich").setValue(null);
      }
    });
  }
  private setFormValues(formGroup: FormGroup, data: any): void {
    for (const controlName in data) {
      if (data.hasOwnProperty(controlName)) {
        const control = formGroup.get(controlName);
        if (control) {
          control.setValue(data[controlName]);
        }
      }
    }
  }
  getValidationStatus(controlName: string, yourForm: FormGroup): string {
    const control = yourForm.get(controlName);
    return  control.invalid ? 'error' : '';
  }
  
}
